export const VERIFIED = 'verified';
export const NOT_VERIFIED = 'not_verified';

export const STATUSES = {
  [VERIFIED]: 'common.status_verified',
  [NOT_VERIFIED]: 'common.status_not_verified',
}
